module.exports = __webpack_public_path__ + "img/svg/stats-background.7c8c1399844b161c5be5baaac319dd57.svg";